export default "/images/arrow-down.svg?1df37166d5bc1c4364d25bcb44ef3180";